import { useEffect, useState } from 'react';
import { fetchTariffSettings, saveTariffSettings } from '@/services/tariffWorkbench.js';
import { shellCard } from './shared.jsx';

// Company-wide valuation settings. MejorTarifa is the equivalent of Clipper's GUIAS.INI option.
export default function ValuationSettingsPanel({ tenant, token }) {
  const [mejorTarifa, setMejorTarifa] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    let active = true;
    fetchTariffSettings({ tenant, token })
      .then((settings) => { if (active) setMejorTarifa(Boolean(settings?.mejorTarifa)); })
      .catch((error) => { if (active) setMessage(error.message); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [tenant, token]);

  const toggle = async (next) => {
    setSaving(true);
    setMessage('');
    try {
      const saved = await saveTariffSettings({ tenant, token, body: { mejorTarifa: next } });
      setMejorTarifa(Boolean(saved?.mejorTarifa));
      setMessage(saved?.mejorTarifa ? 'MejorTarifa activado para toda la empresa.' : 'MejorTarifa desactivado para toda la empresa.');
    } catch (error) {
      setMessage(error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className={`${shellCard} p-5`}>
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[rgba(var(--muted),0.95)]">Configuración de la empresa</p>
      <label className="mt-3 flex items-start gap-3 text-sm text-[rgb(var(--fg))]">
        <input
          type="checkbox"
          className="mt-1"
          checked={mejorTarifa}
          disabled={loading || saving}
          onChange={(event) => toggle(event.target.checked)}
        />
        <span>
          <strong>MejorTarifa: cobrar un solo flete</strong>
          <span className="mt-1 block text-[rgba(var(--muted),0.95)]">
            Cuando a una guía le corresponden varios fletes, se conserva el de mayor importe (si empatan, el último) y los demás quedan en $0 en el desglose.
            Seguro, retiro, entrega y adicionales se siguen sumando. Igual que la opción MejorTarifa de Clipper.
          </span>
        </span>
      </label>
      {message ? <p className="mt-3 text-sm text-[rgb(var(--fg))]" role="status">{message}</p> : null}
    </section>
  );
}
